export default "__VITE_ASSET__046be5e5__"